import { HttpErrorResponse, HttpResponse } from '@angular/common/http';

export class MockTest {

    static criarMockInformacaoCadastro(): any {
        const mockInformacaoCadastro = {
            "nome": "FFZTAWG VCSXSU RC MKOGK",
            "cpf": "000.000.142-22",
            "situacao": "REGULAR",
            "documentoIdentificacao": "",
            "nomeMae": "CIZANRGWZ GHTWQEKUX WK GKYEF",
            "dataNascimento": "27/11/1986",
            "endereco": "TXF SX 60 DY",
            "bairro": "ZONA RURAL",
            "cep": "75955000",
            "cidade": "INDIARA",
            "uf": "GO",
            "telefone": "(85)3062-9999",
            "email": "00000014222@br.experian.com"
        }
        return mockInformacaoCadastro;
    }

    static criarMockNotaDeCredito(): any{
        let mockNotaCredito = {
            "score": 1307,
            "dataUltimaAtualizacao": "10/10/2020"
          };
          return mockNotaCredito;
    }

    static criarMockHistoricoConsultaSerasa(): any{
        let mockHisotiroConsulta = {
            "passagens": [
              {
                "empresa": "SERASA TESTE",
                "cnpj": "47.100.905/0001-05",
                "data": "2020-05-20",
                "quantidadeConsultas": "3"

              },
              {
                "empresa": "OUTRA EMPRESA S/A",
                "cnpj": "49.100.905/0001-02",
                "data": "2020-05-30",
                "quantidadeConsultas": "2"
              }
            ]
          };
          return mockHisotiroConsulta;
    }

    static criarMockHistoricoConsultaSPC(): any{
        let mockHisotiroConsulta = {
            "passagens": [
              {
                "empresa": "SPC TESTE",
                "cnpj": "47.100.905/0001-05",
                "data": "2019-06-10",
                "quantidadeConsultas": "3"
              },
              {
                "empresa": "OUTRA EMPRESA SPC S/A",
                "cnpj": "49.100.905/0001-02",
                "data": "2018-02-15",
                "quantidadeConsultas": "2"
              }
            ]
          };
          return mockHisotiroConsulta;
    }

    static criarMockConsultasSerasaLockUnlock(): any {
      let mockConsultaSerasaLockUnlock = {
        "passagens": [
          {
            "empresa": "UKYCIW GWFMLOE NHTKKE M.C.",
            "cnpj": "61.074.175/0001-38",
            "data": "24/05/2021",
            "quantidadeConsultas": "1"
          }
        ]
      };
      return mockConsultaSerasaLockUnlock;
    }

    static criarMockInformacoesPositivo(): any{

      const mockInformacoesPositivo = {
        "operacoes": [
          {

              "tipoOperacao": "Consórcio",
              "modalidade": "Consórcio",
              "tipoModalidade": "S",
              "numeroOperacao": "00000000000266231442005",
              "empresa": "CAIXA ECONOMICA FEDERAL",
              "cnpj": "00.360.305/0001-04",
              "numeroContrato": "**** **** **62 5201",
              "inicioContrato": "1996-12-14",
              "ultimaAtualizacao": "2019-10-09",
              "agencia": "6507",
              "terminoPrevisto": "",
              "cota": "0",
              "sequencia": "",
              "situacaoCota": "Desconhecido",
              "saldoDevedorTotal": "0.0",
              "totalParcelas": "143",
              "temValorContratado": "0.0",
              "temValorProxParcela": "0.0",
              "detalhe12Meses": [
                {
                  "dataVencimento": "2020-02-10",
                  "valorParcela": "3010.02",
                  "dataPagamento": "2020-02-22",
                  "valorPagamento": "50000"
                },
                {
                  "dataVencimento": "2020-02-15",
                  "valorParcela": "4010.02",
                  "dataPagamento": "2020-02-12",
                  "valorPagamento": "2010.02"
                },                {
                  "dataVencimento": "2020-02-20",
                  "valorParcela": "5010.02",
                  "dataPagamento": "2020-02-20",
                  "valorPagamento": "2010.02"
                }
              ]
            },
            {

              "tipoOperacao": "Consórcio",
              "modalidade": "Consórcio",
              "tipoModalidade": "S",
              "numeroOperacao": "00000000000266231442005",
              "empresa": "CAIXA ECONOMICA FEDERAL",
              "cnpj": "00.360.305/0001-04",
              "numeroContrato": "**** **** **62 5201",
              "inicioContrato": "1996-12-14",
              "ultimaAtualizacao": "2019-10-09",
              "agencia": "6507",
              "terminoPrevisto": "",
              "cota": "0",
              "sequencia": "22",
              "situacaoCota": "Desconhecido",
              "saldoDevedorTotal": "0.0",
              "totalParcelas": "143",
              "temValorContratado": "0.0",
              "temValorProxParcela": "0.0",
              "detalhe12Meses": [
                {
                  "dataVencimento": "2020-02-10",
                  "valorParcela": "3010.02",
                  "dataPagamento": "2020-02-22",
                  "valorPagamento": "50000"
                },
                {
                  "dataVencimento": "2020-02-15",
                  "valorParcela": "4010.02",
                  "dataPagamento": "2020-02-12",
                  "valorPagamento": "2010.02"
                },                {
                  "dataVencimento": "2020-02-20",
                  "valorParcela": "5010.02",
                  "dataPagamento": "2020-02-20",
                  "valorPagamento": "2010.02"
                }
              ]
            },
            {
              "tipoOperacao": "Cartão de Crédito",
              "modalidade": "Cartão de Crédito",
              "tipoModalidade": "C",
              "numeroOperacao": "00000000000266231442005",
              "empresa": "BANCO DO BRASIL",
              "cnpj": "00.360.305/0001-04",
              "numeroContrato": "**** **** **62 5201",
              "inicioContrato": "1996-12-14",
              "ultimaAtualizacao": "2019-10-09",
              "agencia": "6507",
              "ultimosNumerosCartao" : "**** **** *** 5582",
              "valorUltimaFatura": "2636.65",
              "saldoProxFatura": "2200.20",

              "detalhe12Meses": [
                {
                  "dataVencimento": "2020-02-02",
                  "valorParcela": "2010.02",
                  "dataPagamento": "2020-02-02",
                  "valorPagamento": "2010.02"
                }
              ]
            },
            {

              "tipoOperacao": "Rotativo",
              "modalidade": "Rotativo",
              "tipoModalidade": "R",
              "numeroOperacao": "00000000000266231442005",
              "empresa": "ITAU",
              "cnpj": "00.360.305/0001-04",
              "numeroContrato": "**** **** **62 5201",
              "inicioContrato": "1996-12-14",
              "ultimaAtualizacao": "2019-10-09",
              "agencia": "6507",
              "detalhe12Meses": [
                {
                  "dataVencimento": "2020-02-02",
                  "saldoUtilizado": "1330.72",

                }
              ]
            },
            {
              "tipoOperacao": "Parcelado",
              "modalidade": "Consignado",
              "tipoModalidade": "P",
              "numeroOperacao": "187481676",
              "empresa": "SERASA SEGUROS",
              "cnpj": "01.560.707/0001-03",
              "numeroContrato": "783033324",
              "inicioContrato": "25/11/2015",
              "ultimaAtualizacao": "29/12/2019",
              "agencia": "0286",
              "terminoPrevisto": "25/11/2019",
              "valorTotalContrato": 49500.0,
              "totalParcelas": "48",
              "parcelasAVencer": "0",
              "valorProximaParcela": 0.0,
              "detalhe12Meses": [
                  {
                      "dataVencimento": "20/07/2019",
                      "valorParcela": 300.0,
                      "dataPagamento": "21/07/2019",
                      "valorPagamento": 300.0
                  }
              ]
          },
          {

            "tipoOperacao": "Consumo",
            "tipoModalidade": "U",
            "modalidade": "Consumo",
            "empresa": "SANTANDER",
            "cnpj": "00.090.711/0001-05",
            "numeroContrato": "**** **** **12 2021",
            "inicioContrato": "1995-11-24",
            "ultimaAtualizacao": "2019-03-29",
            "valorUltimaParcela": "1000",
            "detalhe12Meses": [
              {
                "dataVencimento": "2020-10-09",
                "valorParcela": "3010.02",
                "dataPagamento": "2020-02-22",
                "valorPagamento": "30000"
              },
              {
                "dataVencimento": "2020-02-15",
                "valorParcela": "4010.02",
                "dataPagamento": "2020-02-12",
                "valorPagamento": "60000"
              },                {
                "dataVencimento": "2020-02-20",
                "valorParcela": "5010.02",
                "dataPagamento": "2020-02-20",
                "valorPagamento": "10000"
              }
            ]
          },
        ]
      }

      return mockInformacoesPositivo;
    }

  static criarMockInformacoesSocietarias(): any {
    let mockInformacoesSocietarias = {
      "sociedades": [
        {
          "cnpj": "04.840.813/0001-40",
          "razaoSocial": "ODERDENGE LOURENZETTI LTDA ME",
          "desde": "01/12/2001",
          "participacao": "99.0%",
          "status": "SITUACAO DO CNPJ EM 27/05/2020: INAPTA",
          "uf": "GO"
        },
        {
          "cnpj": "30.918.117/0001-10",
          "razaoSocial": "MONTE LIBANO EMPREENDIMENTO E PARTICIPAC",
          "desde": "01/09/2009",
          "participacao": "66.6%",
          "status": "SITUACAO DO CNPJ EM 20/05/2020: ATIVA",
          "uf": "GO"
        },
        {
          "cnpj": "01.809.268/0001-31",
          "razaoSocial": "POSTO DO WALMOR LTDA",
          "desde": "01/03/1986",
          "participacao": "1.0%",
          "status": "SITUACAO DO CNPJ EM 04/08/2019: BAIXADA",
          "uf": "GO"
        },
        {
          "cnpj": "37.019.528/0001-12",
          "razaoSocial": "PANIFICADORA E CONFEITARIA DO WALMOR LTD",
          "desde": "01/09/1991",
          "participacao": "0.0%",
          "status": "SITUACAO DO CNPJ EM 29/04/2020: BAIXADA",
          "uf": "GO"
        }
      ]
    };
    return mockInformacoesSocietarias;
  }

  static criarMockDividasPendentes(): any {
    let mockDividasPendentes = {
      "resultados": [
        {
          "empresaCredora": "PANIFICADORA E CONFEITARIA DO WALMOR LTDY",
          "cnpjCredor": "04.670.195/0001-38",
          "contrato": "103280661",
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "03/03/2016",
          "valor": 54.02,
          "natureza": "CRED CARTAO"
        },
        {
          "empresaCredora": "PANIFICADORA E CONFEITARIA DO WALMOR LTRD",
          "cnpjCredor": "04.670.195/0001-38",
          "contrato": "103280661",
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "03/03/2016",
          "valor": 54.02,
          "natureza": "CRED CARTAO"
        },
        {
            "empresaCredora": "PANIFICADORA E CONFEITARIA DO WALMOR LTDX",
            "cnpjCredor": "06.017.546/0001-31",
            "empresaParticipante": "PANIFICADORA E CONFEITARIA DO WALMOR LTD",
            "cnpjParticipante": "04.670.195/0001-38",
            "valor": 10.02,
            "dataOcorrencia": "20/02/2017",
            "dataInclusao": "02/03/2016",
            "natureza": "DUPLICATA DE VENDA MERCANTIL",
            "contrato": "15750834774"
        }
      ]
    };
    return mockDividasPendentes;
  }
resultadosPreNegativos
  static criarMockDividasPendentesPefin(): any {
    let mockDividasPendentesPefin = {
      "resultados": [
        {
          "empresaCredora": "EMPRESA PEFIN",
          "cnpjCredor": "04.670.195/0001-38",
          "contrato": "103280661",
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "03/03/2016",
          "valor": 54.02,
          "natureza": "CRED CARTAO"
      },
      {
          "empresaCredora": "EMPRESA PEFIN2",
          "cnpjCredor": "04.670.195/0001-39",
          "contrato": "103280632",
          "dataOcorrencia": "20/02/2019",
          "dataInclusao": "03/03/2018",
          "valor": 57.02,
          "natureza": "CRED CARTAO"
      }
      ],
      "resultadosPreNegativos" : [
        {
          "empresaCredora": "EMPRESA PEFIN",
          "cnpjCredor": "04.670.195/0001-39",
          "contrato": "103280632",
          "dataOcorrencia": "20/02/2019",
          "dataInclusao": "03/03/2018",
          "dataDisponibilizacao" : "20/05/3000",
          "valor": 1000.02,
          "natureza": "CRED CARTAO"
      }
      ]
    };
    return mockDividasPendentesPefin;
  }

  static criarMockDividasPendentesRefin(): any {
    let mockDividasPendentesRefin = {
      "resultados": [
        {
          "empresaCredora": "EMPRESA REFIN",
          "cnpjCredor": "04.310.392/0001-47",
          "contrato": "123456789",
          "dataOcorrencia": "06/09/2017",
          "dataInclusao": "12/10/2017",
          "valor": 735.1,
          "natureza": "OUTRAS OPER"
        },
        {
          "empresaCredora": "EMPRESA REFIN 2",
          "cnpjCredor": "04.310.392/0001-46",
          "contrato": "123456789",
          "dataOcorrencia": "06/09/2017",
          "dataInclusao": "10/10/2017",
          "valor": 735.11,
          "natureza": "OUTRAS OPER"
        },
        {
          "empresaCredora": "EMPRESA REFIN 3",
          "cnpjCredor": "04.310.392/0001-49",
          "contrato": "123456789",
          "dataOcorrencia": "06/09/2017",
          "dataInclusao": "08/10/2017",
          "valor": 735.12,
          "natureza": "OUTRAS OPER"
        }
      ],
      "resultadosPreNegativos": [
        {
          "empresaCredora": "EMPRESA REFIN",
          "cnpjCredor": "04.670.195/0001-39",
          "contrato": "103280632",
          "dataOcorrencia": "20/02/2019",
          "dataInclusao": "03/03/2018",
          "dataDisponibilizacao": "10/05/3000",
          "valor": 3000.02,
          "natureza": "CRED CARTAO"
      }
      ]
    };
    return mockDividasPendentesRefin;
  }

  static criarMockDividasPendentesConvem(): any {
    let mockDividasPendentesConvem = {
      "resultados": [
        {
          "empresaCredora": "HPEY NFXMHI PKDBKFXJ CW LWOFLNFFT OJFH YF",
          "cnpjCredor": "06.017.546/0001-31",
          "empresaParticipante": "AAAAXXXX CCCCC",
          "cnpjParticipante": "09.017.116/0001-31",
          "valor": 10.01,
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "02/03/2016",
          "natureza": "DUPLICATA DE VENDA MERCANTIL",
          "contrato": "15750834774"
      },
      {
          "empresaCredora": "HPEY NFXMHI PKDBKFXJ CW LWOFLNFFT OJFH YF",
          "cnpjCredor": "06.017.546/0001-31",
          "empresaParticipante": "",
          "cnpjParticipante": "",
          "valor": 10.02,
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "02/03/2016",
          "natureza": "DUPLICATA DE VENDA MERCANTIL",
          "contrato": "15750834774"
      }
    ],
    "resultadosPreNegativos" : [
      {
        "empresaCredora": "EMPRESA CONVEM",
        "cnpjCredor": "04.670.195/0001-39",
        "contrato": "103280632",
        "dataOcorrencia": "20/02/2019",
        "dataInclusao": "03/03/2018",
        "dataDisponibilizacao" : "30/05/3000",
        "valor": 6000.02,
        "natureza": "CRED CARTAO"
    }
    ]
    };
    return mockDividasPendentesConvem;
  }

  static criarMockDividasRegularizadasPefin(): any {
    let mockDividasRegularizadasPefin = {
      "resultados": [
        {
          "empresaCredora": "SERASA EMPY",
          "cnpjCredor": "04.670.195/0001-32",
          "contrato": "103280661",
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "06/03/2016",
          "valor": "54.03",
          "natureza": "CRED CARTAO",
          "dataBaixa": "09/01/2018"
      },
      {
          "empresaCredora": "SERASA EMPZ",
          "cnpjCredor": "04.670.195/0001-38",
          "contrato": "103280661",
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "04/03/2016",
          "valor": "54.02",
          "natureza": "CRED CARTAO",
          "dataBaixa": "09/01/2018"
      }
      ]
    };
    return mockDividasRegularizadasPefin;
  }

  static criarMockDividasRegularizadasRefin(): any {
    let mockDividasRegularizadasRefin = {
      "resultados": [
      {
        "empresaCredora": "Empresa X",
        "cnpjCredor": "04.310.392/0001-46",
        "contrato": "123456789",
        "dataOcorrencia": "06/09/2018",
        "dataInclusao": "12/07/2018",
        "valor": "735.1",
        "natureza": "OUTRAS OPERX",
        "dataBaixa": "31/10/2019"
    },
    {
        "empresaCredora": "Empresa Y",
        "cnpjCredor": "04.310.392/0001-47",
        "contrato": "123456781",
        "dataOcorrencia": "06/08/2018",
        "dataInclusao": "10/06/2018",
        "valor": "735.11",
        "natureza": "OUTRAS OPERY",
        "dataBaixa": "31/10/2020"
    },
    {
        "empresaCredora": "Empresa Z",
        "cnpjCredor": "04.310.392/0001-48",
        "contrato": "123456782",
        "dataOcorrencia": "06/07/2018",
        "dataInclusao": "08/05/2018",
        "valor": "735.12",
        "natureza": "OUTRAS OPERZ",
        "dataBaixa": "31/11/2020"
    }
      ]
    };
    return mockDividasRegularizadasRefin;
  }

  static criarMockDividasRegularizadasConvem(): any {
    let mockDividasRegularizadasConvem = {
      "resultados": [
        {
          "empresaCredora": "HPEY NFXMHI PKDBKFXJ CW LWOFLNFFT OJFH YF1",
          "cnpjCredor": "06.017.546/0001-31",
          "empresaParticipante": "EKA SKWLFHL HH ACOFZ",
          "cnpjParticipante": "00.360.305/0620-53",
          "valor": 20.01,
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "02/03/2016",
          "natureza": "DUPLICATA DE VENDA MERCANTIL",
          "contrato": "15750834774",
          "dataBaixa": "31/12/2016"
      },
      {
          "empresaCredora": "HPEY NFXMHI PKDBKFXJ CW LWOFLNFFT OJFH YF2",
          "cnpjCredor": "06.017.546/0001-31",
          "empresaParticipante": "EKA SKWLFHL HH ACOFZ",
          "cnpjParticipante": "00.360.305/0620-53",
          "valor": 20.02,
          "dataOcorrencia": "20/02/2017",
          "dataInclusao": "02/03/2016",
          "natureza": "DUPLICATA DE VENDA MERCANTIL",
          "contrato": "15750834774",
          "dataBaixa": "31/12/2016"
      }
      ]
    };
    return mockDividasRegularizadasConvem;
  }

  static criarMockDividasAcoesJudiciais(): any {
    let mockDividasAcoesJudiciais = {
      "resultados": [
        {
          "processo": "23456789",
          "valor": "528.4",
          "dataOcorrencia": "15/10/2019",
          "vara": "0002",
          "cidade": "SAO GONCALO DO SAPUCAI",
          "uf": "MG",
          "natureza": "EXECUCAO"
        },
        {
          "processo": "87654321",
          "valor": "528.48",
          "dataOcorrencia": "15/10/2019",
          "vara": "0002",
          "cidade": "SAO GONCALO DO SAPUCAI",
          "uf": "MG",
          "natureza": "EXECUCAO"
        }
      ]
    };
    return mockDividasAcoesJudiciais;
  }

  static criarMockDividasProtestos(): any {
    let mockDividasProtestos = {
      "resultados": [
        {
          "dataVencimento": "29/11/2016",
          "dataInclusao": "02/03/2016",
          "valor": "10.03",
          "numeroCartorio": "02",
          "cartorio": "NAO RESOLVIDO - DISP > INC",
          "cidade": "CAMPOS BELOS",
          "uf": "GO"
      },
      {
          "dataVencimento": "29/11/2016",
          "dataInclusao": "02/03/2016",
          "valor": "10.01",
          "numeroCartorio": "02",
          "cartorio": "NAO RESOLVIDO - DISP = INC",
          "cidade": "CAMPOS BELOS",
          "uf": "GO"
      },
      {
          "dataVencimento": "29/11/2016",
          "dataInclusao": "02/03/2016",
          "valor": "20.02",
          "numeroCartorio": "02",
          "cartorio": "NÃO RESOLVIDO - DISP < INC",
          "cidade": "CAMPOS BELOS",
          "uf": "GO"
      }
      ]
    };
    return mockDividasProtestos;
  }

  static criarMockDividasChequesSemFundos(): any {
    let mockDividasChequesSemFundos = {
      "resultados": [
        {
          "quantidade": "001",
          "banco": "BANCO BRADESCO",
          "agencia": "2022",
          "dataOcorrencia": "13/05/2012",
          "cidade": "ARAUCARIA",
          "uf": "PR"
      },
      {
          "quantidade": "001",
          "banco": "BANCO BRADESCO",
          "agencia": "1205",
          "dataOcorrencia": "12/05/2012",
          "cidade": "ARAUCARIA",
          "uf": "PR"
      }
      ]
    };
    return mockDividasChequesSemFundos;
  }

  static criarMockDividasParticipacaoFalecias(): any {
    let mockDividasParticipacaoFalecias = {
      "resultados": [
        {
          "empresa": "EKA SKWLFHL HH ACOFZ",
          "cnpj": "00.360.305/0620-53",
          "processo": "36599329",
          "dataOcorrencia": "06/08/2004"
      },
      {
          "empresa": "EKA SKWLFHL HH ACOFZ",
          "cnpj": "00.360.305/0620-53",
          "processo": "558565686",
          "dataOcorrencia": "07/08/2004"
      }
      ]
    };
    return mockDividasParticipacaoFalecias;
  }

  static criarMockDividasPendentesParceiros(): any {
    let mockDividasPendentesParceiros = {
      "resultados": [
        {
          "empresa": "EKA SKWLFHL HH ACOFZ",
          "cnpj": "00.360.305/0620-53",
          "contrato": "620.196.00010029",
          "dataOcorrencia": "07/12/2012",
          "dataInclusao": "13/12/2012",
          "valor": "280.02"
        },
        {
          "empresa": "EKA SKWLFHL HH ACOFZ",
          "cnpj": "00.360.305/0620-53",
          "contrato": "620.196.00010029",
          "dataOcorrencia": "07/12/2012",
          "dataInclusao": "13/12/2012",
          "valor": "280.01"
        }
      ]
    };
    return mockDividasPendentesParceiros;
  }

  static criarMockDividasRegularizadasAcoesJudiciais(): any {
    let mockDividasRegularizadasAcoesJudiciais = {
      "resultados": [
        {
          "processo": "23456782",
          "valor": "528.4",
          "dataOcorrencia": "15/10/2019",
          "dataBaixa": "10/05/2020",
          "vara": "0002",
          "cidade": "SAO GONCALO DO SAPUCAI",
          "uf": "MG",
          "natureza": "EXECUCAO"
        },
        {
          "processo": "23456783",
          "valor": "528.4",
          "dataOcorrencia": "15/10/2019",
          "dataBaixa": "10/05/2020",
          "vara": "0002",
          "cidade": "SAO GONCALO DO SAPUCAI",
          "uf": "MG",
          "natureza": "EXECUCAO"
        },
      ]
    };
    return mockDividasRegularizadasAcoesJudiciais;
  }

  static criarMockDividasRegularizadasProtestos(): any {
    let mockDividasRegularizadasProtestos = {
      "resultados": [
        {
          "dataVencimento": "29/11/2016",
          "dataInclusao": "02/03/2016",
          "valor": "20.03",
          "numeroCartorio": "02",
          "cartorio": "RESOLVIDO - DISP > INC",
          "cidade": "CAMPOS BELOS",
          "uf": "GO",
          "dataBaixa": "31/12/2016"
      },
      {
          "dataVencimento": "29/11/2016",
          "dataInclusao": "02/03/2016",
          "valor": "20.03",
          "numeroCartorio": "02",
          "cartorio": "RESOLVIDO - DISP > INC",
          "cidade": "CAMPOS BELOS",
          "uf": "GO",
          "dataBaixa": "31/12/2016"
      }
      ]
    };
    return mockDividasRegularizadasProtestos;
  }


  static criarMockDividasRegularizadasChequesSemFundos(): any {
    let mockDividasChequesSemFundos = {
      "resultados": [
        {
          "quantidade": "001",
          "banco": "BANCO BRADESCO",
          "agencia": "2022",
          "dataOcorrencia": "11/05/2012",
          "cidade": "ARAUCARIA",
          "uf": "PR",
          "dataBaixa": "31/05/2020"
      },
      {
          "quantidade": "001",
          "banco": "BANCO BRADESCO",
          "agencia": "1205",
          "dataOcorrencia": "10/05/2012",
          "cidade": "ARAUCARIA",
          "uf": "PR",
          "dataBaixa": "02/05/2017"
      }
      ]
    };
    return mockDividasChequesSemFundos;
  }

  static criarMockDividasRegularizadasParceiros(): any {
    let mockDividasRegularizadasParceiros = {
      "resultados": [
        {
          "empresa": "ABC DER FBC AAC",
          "cnpj": "02.732.968/0001-38",
          "contrato": "1475839",
          "dataOcorrencia": "28/01/2019",
          "dataInclusao": "13/02/2019",
          "valor": "461.71",
          "dataBaixa": "27/02/2019"
        },
        {
          "empresa": "ZZA FFC RRQW AAZ",
          "cnpj": "03.732.968/0001-50",
          "contrato": "1475840",
          "dataOcorrencia": "28/04/2019",
          "dataInclusao": "17/05/2019",
          "valor": "641.19",
          "dataBaixa": "02/07/2019"
        },
        {
          "empresa": "XXCCAAD WWPPOO 9988",
          "cnpj": "06.732.968/0001-98",
          "contrato": "1475899",
          "dataOcorrencia": "28/07/2019",
          "dataInclusao": "07/08/2019",
          "valor": "477.35",
          "dataBaixa": "10/09/2019"
        }
      ]
    };
    return mockDividasRegularizadasParceiros;
  }

  static criarMockInformacaoCadastroVIPPEP(): any {
    const mockInformacaoCadastroVIPPEP = {
      "vip": true,

    }
    return mockInformacaoCadastroVIPPEP;
  }

  static criarMockRetornoAuthStrongCertificado(): any {
    const x = "eyJhbGciOiJIUzUxMiJ9"
    const y = "eyJleHAiOjE1OTkwOTYzNjIsImp0aSI6NjE1MCwidG9rZW4iOiI4NzEwNzExOC03ZTA4LTRiNDAtODg0OC1iZDU0YjA4MTUyNmIifQ.7kcDi1waaFCFh-5F64nQb24H9pkZxboptCFvliWQ9YmOjGcMQTLk0wpZbBMq0xyOZKs70PGYrCGJC6nQCWmjTw"
    const mockRetornoAuthStrongCertificado = {
      "token":"87107118-7e08-4b40-8848-bd54b081526b",
      "credential":x+"."+y
    }
    return mockRetornoAuthStrongCertificado;
  }

  static criarMockLogin(): any {
    const x = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9"
    const y = "eyJleHAiOjE1OTkwOTM4MjEsImlkIjoiYjdmNzYxNzktNDhjNC00ZmFjLTljMWItNzUxOTMyM2ZhMjc2IiwiaXNzIjoiYXV0aCJ9.nrMZnbWpHiLx-AU2a0dO8rwyOZFFRLKFTHj-YITp_hw"
    const mockLogin = {
      "token":x+"."+y
    }

    return mockLogin;
  }

  static criarMockProtocolo() : any{
    const mockProtocolo = {
      "numeroProtocolo": 16043291587411,
      "dataGeracao": "2020-11-02T14:59:18.741+00:00",
      "documentoCliente": "00000699900",
      "tipoDocumento": 2,
      "acaoCliente": "Relatório Sintetico LGPD",
      "email": "00000699900@br.experian.com"
    }
    return mockProtocolo;
  }

  static criarMockMe(): any {
    const mockMe =  {
      "id":"5f0dc8f666232c7c175911d0",
      "fullName":"TESTES CERTIFICADO DIGITAL",
      "document":{"documentId":"86124897091",
      "documentCountry":"BRA"},
      "birthDate":"1977-05-12",
      "email":{"email":"86124897091@br.experian.com"},
      "mobile":{"regionCode":55,"areaCode":11,"phoneNumber":986124897},
      "userEcs":{"hercules":{"fraudnet":"Aprovado"},
      "picture":"https://www.serasa.com.br/navbar-avatar.png"}
    }
    return mockMe;
  }

  static criarMockOpt(): any {
    const mockOpt = {
      "status": "optin",
      "dataCriacao": "2020-09-02 10:51:06",
      "dataAtualizacao": null,
      "login": "",
      "evento": "Consentimento",
      "protocolo": "15990546669491314561231",
      "meio": 40,
      "origem": 26,
      "protocoloEmAberto": false
    }

    return mockOpt;
  }


  static criarMockHitoricoSolicitacao(): any{
    const finalizado = "Finalizado";
    const origin = "Serasa Consumidor";
    const mockHistoricoSolicitacao = {
      "analyticals":[
         {
            "orderId":"5f984d8484571a000191743d",
            "protocol":"16038168327022",
            "createDate":"2020-10-27 13:40:36",
            "origin":"Portal LGPD",
            "status":finalizado
         },
         {
            "orderId":"5f49667e9de71c0001c9eb72",
            "protocol":"35039",
            "createDate":"2020-08-28 17:18:06",
            "origin":"Sydle",
            "status":finalizado
         },
         {
            "orderId":"5f43f70805723b000113ff0b",
            "protocol":"8888888835",
            "createDate":"2020-08-24 14:21:12",
            "origin":"Sydle",
            "status":finalizado
         }
      ],
      "consent":[
         {
            "protocol":"1605211061160503197704",
            "createDate":"2020-11-12 16:57:41",
            "origin":"LGPD"
         },
         {
            "protocol":"16052015377252140511269",
            "createDate":"2020-11-12 14:18:57",
            "origin":origin
         },
         {
            "protocol":"16015869103321823825806",
            "createDate":"2020-10-01 18:15:10",
            "origin":origin
         },
         {
            "protocol":"16014914348672001639067",
            "createDate":"2020-09-30 15:43:54",
            "origin":origin
         },
         {
            "protocol":"1598622003639282344176",
            "createDate":"2020-08-28 10:40:03",
            "origin":origin
         },
         {
            "protocol":"15973278915051998617458",
            "createDate":"2020-08-13 11:11:31",
            "origin":origin
         },
         {
            "protocol":"1597327857183157204971",
            "createDate":"2020-08-13 11:10:57",
            "origin":origin
         },
         {
            "protocol":"1597069057246496576902",
            "createDate":"2020-08-10 11:17:37",
            "origin":"Portal"
         }
      ]
   }

    return mockHistoricoSolicitacao;
  }

  static criarMockDeclaracaoCompleta(): any {
    return new Blob(["text"], {type: 'text/plain'});
  }

    /**
     *
     * @param codigoErro - codigo do erro http ex: 404, 500, 401 ...
     */
    static criarMockErroHttp(codigoErro: string): any {
        let mockErroHttp: HttpErrorResponse;

        switch (codigoErro) {
            case '404':
                mockErroHttp = new HttpErrorResponse({ error: this.erro404(), status: 404 });
                break;
            case '500':
                mockErroHttp = new HttpErrorResponse({ error: this.erro500(), status: 500 });
                break;
            case '503':
                mockErroHttp = new HttpErrorResponse({ error: this.erro503(), status: 503 });
                break;

        }
        return mockErroHttp;
    }

    static criarMockHttp(body: string, codigo: string): any {
      let mockHttp =  new HttpResponse();
      switch (codigo) {
          case '200':
              mockHttp = new HttpResponse({ body: body, status: 200 });
              break;
      }
      return mockHttp;
  }

    // Mock Retorno de erros http
    private static erro404(): any {
        let mockErro404 = [
            {
                "code": "404.9",
                "message": "Nenhuma consulta ao CPF encontrada"
            }
        ];
        return mockErro404;
    }

    private static erro500(): any {
        let mockErro500 = [
            {
                "code": "500.9",
                "message": "Erro interno"
            }
        ];
        return mockErro500;
    }

    private static erro503(): any {
      let mockErro503 = [
          {
              "code": "503.9",
              "message": "Erro interno XDSS"
          }
      ];
      return mockErro503;
  }

}
